<template>
	<div class="main-containter" v-title data-title="和华利盛">
		<FHeader :checkId="28"></FHeader>
		<FOtherBanner :name1="'加入我们'" :name2="'Join Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 100%;">
			<div style="width: 64%;padding: 30px 18%;">
				<div style="height:170px;width:100%;">
					<img style="height:100%;width:100%;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/joinus.png">
				</div>
				<div style="margin-top: 30px;font-size: 14px;">
					发布日期：{{item.publish.substring(0,10)}}
				</div>
				<div style="margin-top: 15px;font-weight: 900;font-size: 18px;color: #333333;">
					{{item.name}}
				</div>
				<div style="margin-top: 15px;font-size: 14px;color: rgb(51, 51, 51);padding-bottom: 15px;">
					{{item.type+" | "+item.address+" | "+'简历投递：'}}<span style="color:#98273A;">{{item.email}}</span>
				</div>
				<div style="width: 100%;height: 1px;background-size: 20px 10px;background-repeat: repeat-x;background-image: linear-gradient(to right, #D7D7D7 0%, #D7D7D7 50%, transparent 75%);"></div>
				<div style="margin-top: 20px;color: #333333;">
					岗位职责:
				</div>
				<div style="white-space: pre-wrap;margin-top: 20px;font-size: 14px;color: #555555;line-height: 25px;">{{item.responsibility}}</div>
				<div style="margin-top: 20px;color: #333333;">
					任职资格:
				</div>
				<div style="white-space: pre-wrap;margin-top: 20px;font-size: 14px;color: #555555;line-height: 25px;margin-bottom:50px;">{{item.qualification}}</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {query} from "@/api/joinUs";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				item: {}
			}
		},
		created() {
			this.item = JSON.parse(this.$route.query.item)
			console.log(this.item)
		},
		mounted() {
			this.item = JSON.parse(this.$route.query.item)
			console.log(this.item)
		},
		activated(){
			this.item = JSON.parse(this.$route.query.item)
			console.log(this.item)
		},
		
		watch: {
		},
		methods: {
		}
	}
</script>
<style lang="scss" scoped="scoped">
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
